module.exports = __webpack_public_path__ + "static/media/Ranvijay Sachan - Resume.154d5f32.pdf";